import { type Brand } from '@/consts/brands';
import { type RegistrationEligibilityDataType } from '@/types/eligibility/eligibility';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

export const transitionOtcSignupUser = async (
  brand: Brand,
  eligibilityData: Partial<RegistrationEligibilityDataType>,
) => {
  return await post(
    urls[brand].api.eligibility.transitionOtcSignupUser,
    eligibilityData,
  );
};
